export default [
  {
    path: '/admin/marketing/cashback/list',
    name: 'MarketingCashbackList',
    component: ()=>import('@/views/marketing/cashback/list'),
    meta: {
      title: '返现活动-列表',
      keepAlive: false
    }
  },
  {
    path: '/admin/marketing/cashback/edit',
    name: 'MarketingCashbackEdit',
    component: ()=>import('@/views/marketing/cashback/edit'),
    meta: {
      title: '返现活动-编辑',
      keepAlive: false
    }
  },
  {
    path: '/admin/marketing/cashback/fund_log',
    name: 'MarketingCashbackFundLog',
    component: ()=>import('@/views/marketing/cashback/fund_log'),
    meta: {
      title: '返现活动-返现日志',
      keepAlive: false
    }
  },
]



// WEBPACK FOOTER //
// ./src/router/marketing.js